import { AnchorWithLink } from 'atoms/Anchor';
import React from 'react';
import { formatPhoneNumber } from 'common/utilities/utils';
import { ACCOUNT_SETTINGS } from './../../Constants/Constants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import DayJsUtil from '@kfc-global/react-shared/utils/DayJSUtils';
import EditPersonalInfo from './EditPersonalInfo';
import { DATE_FORMATS } from 'common/constants/SharedConstants';

const PersonalInfoCard = ({
  profileReducer,
  authReducer,
  tenantReducer,
  editAccountInfoModal,
  updateCustomerData,
  isMobile,
  openEditInfoFlag,
}) => {
  const { basic: personalBasicData = {} } = profileReducer || {};
  const { firstName, lastName, email, phone, dateOfBirth, postalCode } = personalBasicData;
  const { PERSONAL_INFO_TEXT, EDIT, NAME, EMAIL_ADDRESS, MOBILE_NUMBER, DATE_OF_BIRTH, POSTAL_CODE } = ACCOUNT_SETTINGS;
  const { isPostalCodeMandtoryField, postalCodesLength } = tenantReducer;
  const {
    web: {
      global: {
        allowOtpPopup = false,
        isEnablePostalCodeSignUp = false,
        maxLengthPhoneNumber = '',
        postalCodeRegex = '',
        postalCodeFormatNumber,
      } = {},
      accountPage: { validateNameRegex = '' } = {},
    } = {},
    checkout: { phoneNumberRegExp = '' } = {},
  } = tenantReducer?.componentOptions ?? {};
  const date = dateOfBirth?.split('-');
  const month = DayJsUtil.format({ date: date?.[1], outPutFormat: translateWithI18Next(DATE_FORMATS?.MMMM) });
  const dob = `${translateWithI18Next(date?.[2])} ${translateWithI18Next(month)}  ${translateWithI18Next(date?.[0])}`;

  const renderEditInfoText = () => {
    return (
      <div className='edit-input edit-info-link'>
        <AnchorWithLink
          data-testid='edit-account-button-testid'
          onClickHandler={() => editAccountInfoModal('fromEditClick')}
        >
          {translateWithI18Next(EDIT)}
        </AnchorWithLink>
      </div>
    );
  };

  const renderPersonalInfo = () => {
    return (
      <div className='personal-info-card'>
        <div className='personal-card-left-side'>
          {translateWithI18Next(PERSONAL_INFO_TEXT)}
          {isMobile && renderEditInfoText()}
        </div>
        <div className='personal-card-right-side'>
          {!isMobile && renderEditInfoText()}
          <div className='personal-info-section'>
            <div className='personal-data-view'>
              <div>{translateWithI18Next(NAME)}</div>
              <div>
                {' '}
                {firstName} {lastName}
              </div>
            </div>

            <div className='personal-data-view'>
              <div>{translateWithI18Next(EMAIL_ADDRESS)}</div>
              <div> {email}</div>
            </div>
            <div className='personal-data-view'>
              <div>{translateWithI18Next(MOBILE_NUMBER)}</div>
              <div>
                {' '}
                {formatPhoneNumber(
                  phone,
                  tenantReducer?.componentOptions?.phoneNumberConstants?.phoneRegexPattern,
                  tenantReducer?.componentOptions?.phoneNumberConstants?.splitPattern,
                  maxLengthPhoneNumber,
                )}
              </div>
            </div>

            {isEnablePostalCodeSignUp && postalCode && (
              <div className='personal-data-view' data-testid='postal-code-view'>
                <div>{translateWithI18Next(POSTAL_CODE)}</div>
                <div> {postalCode}</div>
              </div>
            )}

            {dateOfBirth && (
              <div className='personal-data-view'>
                <div>{translateWithI18Next(DATE_OF_BIRTH)}</div>
                <div>{dob}</div>
              </div>
            )}
          </div>
        </div>
        {}
      </div>
    );
  };

  const renderEditInfoForm = () => {
    return (
      <EditPersonalInfo
        isMobile={isMobile}
        firstName={firstName}
        lastName={lastName}
        email={email}
        phone={phone}
        postalCode={postalCode}
        dateOfBirth={dateOfBirth}
        dob={dob}
        editAccountInfoModal={editAccountInfoModal}
        updateCustomerData={updateCustomerData}
        isEnablePostalCodeSignUp={isEnablePostalCodeSignUp}
        phoneNumberRegex={phoneNumberRegExp}
        postalCodeRegex={postalCodeRegex}
        phonePattern={tenantReducer?.componentOptions?.phoneNumberConstants?.phoneRegexPattern}
        splitPattern={tenantReducer?.componentOptions?.phoneNumberConstants?.splitPattern}
        postalCodeFormatNumber={postalCodeFormatNumber}
        maxLengthPhoneNumber={maxLengthPhoneNumber}
        validateNameRegex={validateNameRegex}
        allowOtpPopup={allowOtpPopup}
        postalCodesLength={postalCodesLength}
        isPostalCodeMandtoryField={isPostalCodeMandtoryField}
      />
    );
  };
  return !openEditInfoFlag ? renderPersonalInfo() : renderEditInfoForm();
};
export default PersonalInfoCard;
